import { createAction, props } from '@ngrx/store';
import { IMeta, IRequestOptions } from './../../../app/@store/request-options.interface';
import { ColumnSortEvent } from '@gridscale/ingrid/components/data-table';
import { BillingAddress } from './../../../app/@shared/models/billing.model'
import { contractmanagement_api } from '@gridscale/gs-services/contractmanagement_api'; import { AccountResponse } from './../../../app/@shared/models/account_response.model';
import { AccountsResponse } from './../../../app/@shared/models/accounts_response.model';
import { AccountUsersResponse } from './../../../app/@shared/models/account_users_response.model';
import { AccountFeatureFlagsResponse } from './../../../app/@shared/models/account_feature_flags_response.model';
import { GSError } from '@gridscale/gsclient-js';
import { PaymentMethodsWhitelistResponseData } from '../../@shared/models/paymentMethod.model';

export const actionPrefix = '[contracts]';

export const setListConfig = createAction(actionPrefix + ' Set List Config', props<{ config: IRequestOptions }>());

export const loadAccounts = createAction(actionPrefix + ' Load List', props<{ fromBatch?: boolean }>());
export const loadAccountsSuccess = createAction(actionPrefix + ' Load List Success', props<{ data: AccountsResponse['contracts']; meta: IMeta }>());
export const loadAccountsFailure = createAction(actionPrefix + ' Load List Failure', props<{ error: GSError }>());

export const loadAccountsTotal = createAction(actionPrefix + ' Load Total');
export const loadAccountsTotalSuccess = createAction(actionPrefix + ' Load Total Success', props<{ total: number }>());
export const loadContractsTotalFailure = createAction(actionPrefix + ' Load Total Failure', props<{ error: GSError }>());

export const loadFavAccounts = createAction(actionPrefix + ' Load Favs');
export const loadFavAccountsSuccess = createAction(actionPrefix + ' Load Favs Success', props<{ data: AccountsResponse['contracts'] }>());
export const loadFavAccountsFailure = createAction(actionPrefix + ' Load Favs Failure', props<{ error: GSError }>());

export const tableChangeSort = createAction(actionPrefix + ' Change Sort', props<{ newSort: ColumnSortEvent; fromBatch?: boolean }>());
export const setSearch = createAction(actionPrefix + ' Set User List Searchterm', props<{ search: string }>());

export const loadAccountsNext = createAction(actionPrefix + ' Load List Next');
export const loadAccountsNextSuccess = createAction(actionPrefix + ' Load List Next Success', props<{ data: AccountsResponse['contracts']; meta: IMeta }>());
export const loadAccountsNextFailure = createAction(actionPrefix + ' Load List Next Failed', props<{ error: Error }>());

export const loadAccount = createAction(actionPrefix + ' Load', props<{ account_uuid: string; fromBatch?: boolean }>());
export const loadAccountSuccess = createAction(actionPrefix + ' Load Success', props<{
  data: Partial<AccountResponse['contract']>;
  management_data: Partial<contractmanagement_api.ContractDetailAttributes>;
  details: Partial<contractmanagement_api.ContractDetailsAttributes>;
  billing_address: contractmanagement_api.BillingAddressAttributes | null;
  account_uuid: string;
  payment_methods_whitelist: PaymentMethodsWhitelistResponseData[];
}>());
export const loadAccountFailure = createAction(actionPrefix + ' Load Failure', props<{ error: GSError; account_uuid: string }>());

export const loadAccountOnly = createAction(actionPrefix + ' Load only', props<{ account_uuid: string; fromBatch?: boolean }>());
export const loadAccountOnlySuccess = createAction(actionPrefix + ' Load only Success', props<{
  data: Partial<AccountResponse['contract']>;
  account_uuid: string;
}>());
export const loadAccountOnlyFailure = createAction(actionPrefix + ' Load only Failure', props<{ error: GSError; account_uuid: string }>());

// Load Project Informations!
export const loadAllAccountProjects = createAction(actionPrefix + ' Load All Projects');
export const loadAllAccountsProjectsSuccess = createAction(actionPrefix + ' Load All Projects Success', props<{ count: number; page_size: number; page: number }>());
export const loadAllContractsProjectsFailure = createAction(actionPrefix + ' Load All Projects Failure', props<{ error: GSError }>());

export const loadAllContractsProjectsSingleCallNames = createAction(actionPrefix + ' Load All Single Projects', props<{ page_size: number; page: number; count: number }>());
export const loadAllAccountsProjectsSingleCallSuccess = createAction(actionPrefix + ' Load All Single Projects Success', props<{ result: Partial<AccountsResponse['contracts']> }>());
export const loadAllContractsProjectsSingleCallFailure = createAction(actionPrefix + ' Load All Single Projects Failure', props<{ error: GSError }>());

// Load Account Users
export const loadAccountUsers = createAction(actionPrefix + ' Load contract users', props<{ account_uuid: string }>());
export const loadAccountUsersSuccess = createAction(actionPrefix + ' Load contract users success', props<{ account_uuid: string; data: AccountUsersResponse['user_relations'] }>());
export const loadAccountUsersFailure = createAction(actionPrefix + ' Load contract users failure', props<{ error: Error; account_uuid: string }>());

// Load Account Feature Flag
export const loadAccountFeatureFlag = createAction(actionPrefix + ' Load contract feature flags', props<{ account_uuid: string }>());
export const loadAccountFeatureFlagSuccess = createAction(actionPrefix + ' Load contract feature flags success', props<{ account_uuid: string; data: AccountFeatureFlagsResponse['feature_flags'] }>());
export const loadAccountFeatureFlagFailure = createAction(actionPrefix + ' Load contract feature flags failure', props<{ error: Error; account_uuid: string }>());

export const patchContractFeatureFlag = createAction(actionPrefix + ' Patch contract feature flags', props<{ account_uuid: string; data: { values: Record<string, boolean | null> } }>());
export const patchAccountFeatureFlagSuccess = createAction(actionPrefix + ' Patch contract feature flags success', props<{ account_uuid: string; fromBatch?: boolean }>());
export const patchContractFeatureFlagFailure = createAction(actionPrefix + ' Patch contract feature flags failure', props<{ error: Error; account_uuid: string }>());

export const patchContractLimits = createAction(actionPrefix + ' Patch contract limits', props<{ account_uuid: string; data: Record<string, number | null> }>());
export const patchContractLimitsSuccess = createAction(actionPrefix + ' Patch contract limits success', props<{ account_uuid: string; fromBatch?: boolean }>());
export const patchContractLimitsFailure = createAction(actionPrefix + ' Patch contract limits failure', props<{ error: Error; account_uuid: string }>());

export const patchContractPaymentMode = createAction(actionPrefix + ' Patch contract payment mode', props<{ account_uuid: string; data: { payment_mode: contractmanagement_api.ContractPaymentModePatchRequestBody.PaymentModeEnum | string } }>());
export const patchAccountPaymentModeSuccess = createAction(actionPrefix + ' Patch contract payment mode success', props<{ account_uuid: string; fromBatch?: boolean }>());
export const patchContractPaymentModeFailure = createAction(actionPrefix + ' Patch contract payment mode failure', props<{ error: Error; account_uuid: string }>());

/**
 * this sets the contract disconnect MODE
 */
export const patchContractDisconnectMode = createAction(actionPrefix + ' Patch contract disconnect mode', props<{ account_uuid: string; data: { disconnect_mode: contractmanagement_api.ContractDisconnectMode | string } }>());
export const patchContractDisconnectModeSuccess = createAction(actionPrefix + ' Patch contract disconnect mode success', props<{ account_uuid: string; fromBatch?: boolean }>());
export const patchContractDisconnectModeFailure = createAction(actionPrefix + ' Patch contract disconnect mode failure', props<{ error: Error; account_uuid: string }>());

/**
 * this really disconnects/connects the account from the internet
 */
export const patchContractDisconnected = createAction(actionPrefix + ' Patch contract disconnected', props<{ account_uuid: string; data: { disconnected: boolean } }>());
export const patchContractDisconnectedSuccess = createAction(actionPrefix + ' Patch contract disconnected success', props<{ account_uuid: string; fromBatch?: boolean }>());
export const patchContractDisconnectedFailure = createAction(actionPrefix + ' Patch contract disconnected failure', props<{ error: Error; account_uuid: string }>());


export const patchPaymentTerm = createAction(actionPrefix + ' Patch payment term', props<{ account_uuid: string; data: { payment_term: contractmanagement_api.PaymentTerm; } }>());
export const patchPaymentTermSuccess = createAction(actionPrefix + ' Patch payment term success', props<{ account_uuid: string; fromBatch?: boolean }>());
export const patchPaymentTermFailure = createAction(actionPrefix + ' Patch payment term failure', props<{ error: Error; account_uuid: string }>());


export const patchViaContractManagement = createAction(actionPrefix + ' Patch via contract management', props<{ account_uuid: string; data: contractmanagement_api.ContractDetailsAttributes }>());
export const patchViaContractManagementSuccess = createAction(actionPrefix + ' Patch via contract management success', props<{ account_uuid: string; fromBatch?: boolean }>());
export const patchViaContractManagementFailure = createAction(actionPrefix + ' Patch via contract management failure', props<{ error: Error; account_uuid: string }>());


export const patchAccountUser = createAction(
  actionPrefix + ' Patch Account User relations',
  props<{ account_uuid: string; partner_uuid?: string; user_uuid: string; data: Partial<Omit<AccountUsersResponse['user_relations'][0], 'relations'>>; fromBatch?: boolean }>()
);
export const patchAccountUserSuccess = createAction(
  actionPrefix + ' Patch Account User relations success',
  props<{ account_uuid: string; user_uuid: string; request_id?: string; fromBatch?: boolean }>()
);
export const patchContractUserFailure = createAction(actionPrefix + ' Patch Account User relations failure', props<{ error: Error }>());

export const postContractUser = createAction(
  actionPrefix + ' Post Account User relations',
  props<{ account_uuid: string; user_uuid: string; user_role: string; fromBatch?: boolean }>()
);
export const postAccountUserSuccess = createAction(
  actionPrefix + ' Post Account User relations success',
  props<{ account_uuid: string; user_uuid: string; request_id?: string; fromBatch?: boolean }>()
);
export const postContractUserFailure = createAction(actionPrefix + ' Post Account User relations failure', props<{ error: Error }>());

export const removeAccountUser = createAction(actionPrefix + ' Remove Account User relations', props<{ account_uuid: string; user_uuid: string; fromBatch?: boolean }>());
export const removeAccountUserSuccess = createAction(
  actionPrefix + ' Remove Account User relations success',
  props<{ account_uuid: string; user_uuid: string; request_id?: string; fromBatch?: boolean }>()
);
export const removeAccountUserFailure = createAction(actionPrefix + ' Remove Account User relations failure', props<{ error: Error }>());

export const patchAccount = createAction(actionPrefix + ' Patch Account', props<{ account_uuid: string; data: Partial<Omit<AccountResponse['contract'], 'relations'>>; fromBatch?: boolean }>());
export const patchAccountSuccess = createAction(actionPrefix + ' Patch Account Success', props<{ account_uuid: string; data: Partial<Omit<AccountResponse['contract'], 'relations'>>; request_id: string; fromBatch?: boolean }>());
export const patchAccountFailure = createAction(actionPrefix + ' Patch Account Failure', props<{ error: Error; account_uuid: string }>());

export const patchAccountLegacy = createAction(actionPrefix + ' Patch Account Legacy', props<{
  account_uuid: string;
  data: {
    cost_center?: string;
    reference?: string;
  };
  fromBatch?: boolean
}>());
export const patchAccountLegacySuccess = createAction(
  actionPrefix + ' Patch Account Legacy Success',
  props<{
    account_uuid: string;
    data: {
      cost_center?: string;
      reference?: string;
    };
    request_id: string;
    fromBatch?: boolean
  }>()
);
export const patchContractLegacyFailure = createAction(actionPrefix + ' Patch Account Legacy Failure', props<{ error: Error; account_uuid: string }>());

export const deleteAccount = createAction(actionPrefix + ' Delete Account', props<{ account_uuid: string; fromBatch?: boolean }>());
export const deleteAccountSuccess = createAction(actionPrefix + ' Delete Account Success', props<{ account_uuid: string; request_id: string; fromBatch?: boolean }>());
export const deleteAccountFailure = createAction(actionPrefix + ' Delete Account Failure', props<{ error: Error; account_uuid: string }>());

export const toggleFavorite = createAction(actionPrefix + ' Flag Account Favorite', props<{ account_uuid: string; favorite: boolean; fromBatch?: boolean }>());
export const toggleFavoriteSuccess = createAction(
  actionPrefix + ' Flag Account Favorite Success',
  props<{ account_uuid: string; request_id?: string; favorite: boolean; fromBatch?: boolean }>()
);
export const toggleFavoriteFailure = createAction(actionPrefix + ' Flag Account Favorite Failure', props<{ error: Error; account_uuid: string }>());

export const createAccount = createAction(actionPrefix + ' Create Account', props<{
  data: {
    account_name: string;
    default_location_uuid: string;
    payment_enabled: boolean;
    user_uuid?: string;
    project_name?: string;
  };
  fromBatch?: boolean
}>());
export const createAccountSuccess = createAction(actionPrefix + ' Create Account Success', props<{ account_uuid: string; fromBatch?: boolean }>());
export const createAccountFailure = createAction(actionPrefix + ' Create Account Failure', props<{ error: Error }>());


export const patchBillingAddress = createAction(actionPrefix + ' Patch account billing address', props<{ account_uuid: string; data: BillingAddress }>());
export const patchBillingAddressSuccess = createAction(actionPrefix + ' Patch account billing address success', props<{ account_uuid: string; data: BillingAddress; fromBatch?: boolean }>());
export const patchBillingAddressFailure = createAction(actionPrefix + ' Patch account billing address failure', props<{ error: Error; account_uuid: string }>());

export const patchPaymentMethodsWhitelist = createAction(actionPrefix + ' Patch payment methods whitelist', props<{ account_uuid: string; data: { payment_method_type: string, allowed: boolean }, fromBatch?: boolean }>());
export const patchPaymentMethodsWhitelistSuccess = createAction(actionPrefix + ' Patch payment methods whitelist success', props<{ account_uuid: string; data: any, fromBatch?: boolean }>());
export const patchPaymentMethodsWhitelistFailure = createAction(actionPrefix + ' Patch payment methods whitelist failure', props<{ error: Error; account_uuid: string }>());

export const toggleDiscountCalculator = createAction(actionPrefix + ' toggle discount calculator');
